import { Routes, Route, Navigate } from 'react-router-dom';
import { CoachDashboard } from '@/apps/coach/pages/Dashboard';
import { CoachWelcome } from '@/apps/coach/pages/Welcome';
import { CoachSettings } from '@/apps/coach/pages/Settings';
import { ClientDetail } from '@/apps/coach/pages/ClientDetail';
import { SessionDetail } from '@/apps/coach/pages/SessionDetail';
import { ReportDetail } from '@/apps/coach/pages/ReportDetail';
import { OperatorDashboard } from '@/apps/coach/pages/platform/Dashboard';
import { VoucherList } from '@/apps/coach/pages/platform/VoucherList';
import { VoucherCreate } from '@/apps/coach/pages/platform/VoucherCreate';
import { VoucherDetail } from '@/apps/coach/pages/platform/VoucherDetail';
import { UserList } from '@/apps/coach/pages/platform/UserList';
import { UserDetail } from '@/apps/coach/pages/platform/UserDetail';
import { Analytics } from '@/apps/coach/pages/platform/Analytics';
import { AnnouncementList } from '@/apps/coach/pages/platform/AnnouncementList';
import { CoachInviteList } from '@/apps/coach/pages/platform/CoachInviteList';
import { Apps } from '@/apps/coach/pages/Apps';

/**
 * Router for coach.teamity.io (Coach-Workspace + Operator).
 * NO /admin prefix — the subdomain is the Coach identity.
 *
 * Page imports point to legacy paths; Task 10 git mv's them
 * into src/apps/coach/pages/ and imports follow.
 *
 * Route paths still carry /admin temporarily because hardcoded
 * navigate() calls exist all over the place. Task 11 sweeps them
 * to use the routes.coach.*() helpers without the /admin prefix.
 */
export function CoachRouter() {
  return (
    <Routes>
      <Route path="/" element={<CoachDashboard />} />
      <Route path="/welcome" element={<CoachWelcome />} />
      <Route path="/einstellungen" element={<CoachSettings />} />
      <Route path="/klienten/:id" element={<ClientDetail />} />
      <Route path="/klienten/:clientId/sessions/:sessionId" element={<SessionDetail />} />
      <Route path="/klienten/:clientId/reports/:reportId" element={<ReportDetail />} />
      <Route path="/apps" element={<Apps />} />
      <Route path="/plattform" element={<OperatorDashboard />} />
      <Route path="/plattform/vouchers" element={<VoucherList />} />
      <Route path="/plattform/vouchers/new" element={<VoucherCreate />} />
      <Route path="/plattform/vouchers/:code" element={<VoucherDetail />} />
      <Route path="/plattform/nutzer" element={<UserList />} />
      <Route path="/plattform/nutzer/:id" element={<UserDetail />} />
      <Route path="/plattform/analytics" element={<Analytics />} />
      <Route path="/plattform/announcements" element={<AnnouncementList />} />
      <Route path="/plattform/coaches" element={<CoachInviteList />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
